import { CreateAlbumResult } from '../../..';

export enum AddTeamMemberStatus {
  Added = 'added',
  AlreadyInAnotherTeam = 'already-in-another-team',
  AlreadyMember = 'already-member',
  CreatedAndAdded = 'created-and-added',
  DomainNotAllowed = 'domain-not-allowed',
  Duplicate = 'duplicate',
  ErrorCreating = 'error-creating',
  ErrorUnknown = 'error-unknown',
  InvalidEmail = 'invalid-email',
}

interface CreateAlbumResultCreated extends CreateAlbumResult {
  status: 'created';
}

interface CreateAlbumResultError {
  status: 'error';
  error: string;
}

export type AddTeamMemberCreateAlbumResult = CreateAlbumResultCreated | CreateAlbumResultError;

export interface AddTeamMemberBaseResult {
  added: boolean;
  email: string;
  status: AddTeamMemberStatus;
}

export interface AddTeamMemberSuccessResult extends AddTeamMemberBaseResult {
  added: true;
  createAlbumResult: AddTeamMemberCreateAlbumResult | null;
  status: AddTeamMemberStatus.Added | AddTeamMemberStatus.CreatedAndAdded;
  userId: string;
}

export interface AddTeamMemberAlreadyMemberResult extends AddTeamMemberBaseResult {
  added: false;
  status: AddTeamMemberStatus.AlreadyMember;
  userId: string;
}

export interface AddTeamMemberSkipCasesTeamResult extends AddTeamMemberBaseResult {
  added: false;
  status:
    | AddTeamMemberStatus.AlreadyInAnotherTeam
    | AddTeamMemberStatus.DomainNotAllowed
    | AddTeamMemberStatus.Duplicate
    | AddTeamMemberStatus.InvalidEmail;
}

export interface AddTeamMemberErrorResult extends AddTeamMemberBaseResult {
  added: false;
  status: AddTeamMemberStatus.ErrorCreating | AddTeamMemberStatus.ErrorUnknown;
  error: string;
}

export type AddTeamMemberResult =
  | AddTeamMemberSuccessResult
  | AddTeamMemberAlreadyMemberResult
  | AddTeamMemberSkipCasesTeamResult
  | AddTeamMemberErrorResult;

export type AddTeamMemberIsMemberResult =
  | AddTeamMemberSuccessResult
  | AddTeamMemberAlreadyMemberResult;

export function isAddTeamMemberSuccessResult(
  item: AddTeamMemberResult,
): item is AddTeamMemberSuccessResult {
  return [AddTeamMemberStatus.Added, AddTeamMemberStatus.CreatedAndAdded].includes(item.status);
}

export function isAddTeamMemberAlreadyMemberResult(
  item: AddTeamMemberResult,
): item is AddTeamMemberAlreadyMemberResult {
  return [AddTeamMemberStatus.AlreadyMember].includes(item.status);
}

export function isAddTeamMemberSkipCasesTeamResult(
  item: AddTeamMemberResult,
): item is AddTeamMemberSkipCasesTeamResult {
  return [
    AddTeamMemberStatus.AlreadyInAnotherTeam,
    AddTeamMemberStatus.DomainNotAllowed,
    AddTeamMemberStatus.Duplicate,
    AddTeamMemberStatus.InvalidEmail,
  ].includes(item.status);
}

export function isAddTeamMemberErrorResult(
  item: AddTeamMemberResult,
): item is AddTeamMemberErrorResult {
  return [AddTeamMemberStatus.ErrorCreating, AddTeamMemberStatus.ErrorUnknown].includes(
    item.status,
  );
}

export function isAddTeamMemberIsMemberResult(
  item: AddTeamMemberResult,
): item is AddTeamMemberIsMemberResult {
  return [
    AddTeamMemberStatus.Added,
    AddTeamMemberStatus.AlreadyMember,
    AddTeamMemberStatus.CreatedAndAdded,
  ].includes(item.status);
}
